// An acacia: a tall bare trunk that splits, crowned by a wide, FLAT-TOPPED
// umbrella made of overlapping flattened foliage blobs (not a clean disc) — the
// iconic savanna silhouette. Ported 1:1 from age-of-mcp's classic tree-acacia.ts,
// restoring its branch helper and umbrella-canopy loop.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(): Part[] {
  const canopyY = 1.5;
  const parts: Part[] = [
    { geometry: new THREE.CylinderGeometry(0.06, 0.13, 1.15, 5),
      color: "#6e5836", position: [0, 0.575, 0] },
  ];
  // two branches angling up to the canopy from the trunk top.
  const branch = (a: number): Part => ({
    geometry: new THREE.CylinderGeometry(0.03, 0.05, 0.55, 4),
    color: "#6e5836",
    position: [Math.cos(a) * 0.18, 1.15 + 0.22, Math.sin(a) * 0.18],
    rotation: [Math.sin(a) * 0.7, 0, -Math.cos(a) * 0.7],
  });
  parts.push(branch(0), branch(Math.PI));
  // Umbrella canopy: a ring of flattened foliage blobs at one height, so the
  // top reads as a broad, slightly lumpy flat crown rather than a plate.
  const N = 7;
  for (let i = 0; i < N; i++) {
    const a = (i / N) * Math.PI * 2;
    parts.push({
      geometry: new THREE.IcosahedronGeometry(0.34, 0),
      color: i % 2 ? "#5f8a3c" : "#6e9c46",
      position: [Math.cos(a) * 0.46, canopyY, Math.sin(a) * 0.46],
      scale: [1, 0.42, 1],            // flatten -> umbrella
    });
  }
  // a low centre blob to fill the middle
  parts.push({ geometry: new THREE.IcosahedronGeometry(0.42, 0), color: "#669340",
    position: [0, canopyY - 0.02, 0], scale: [1, 0.4, 1] });
  return parts;
}

export const treeAcacia = defineModel({
  id: "tree-acacia",
  batchId: "standard",
  name: "Tree acacia",
  tags: ["scenery","tree","acacia","low-poly","age-of-mcp","classic"],
  summary: "Low-poly tree acacia.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.75,
  parts: () => partsFor(),
  animations: [],
});
